import { Container } from 'react-bootstrap';

const DatosExperiencia = ({ experiencia, ruta }) => {

    var imagen = "/images/web/bedloop-nofoto.png";

    if (experiencia.imagen) {
        imagen = ruta + "/experiencias/" + experiencia.id + "/" + experiencia.imagen;
    }
    return (
        <div className="pb-3 potblur" style={{ paddingTop: '4rem' }}>
            <div className="imatge-banner" title={experiencia.elnombre} style={{ backgroundImage: "url('" + imagen + "')", backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: "cover" }}></div>
            <h1 className="mb-5 text-center">{experiencia.elnombre}</h1>
            <Container>
                <div className="noticia-individual-descripcio-llarga">
                    <div dangerouslySetInnerHTML={{ __html: experiencia.eltexto }}></div>
                </div>
            </Container>
        </div>
    );
}

export default DatosExperiencia;
